import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { ReportsService } from "src/app/_Reports/services/reports.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { QuickLoanService } from "../services/quickLoan.service";

@Component({
  selector: "app-quickloan-appilcation-status-report",
  templateUrl: "./quickloan-appilcation-status-report.component.html",
  styleUrls: ["./quickloan-appilcation-status-report.component.scss"],
  standalone: false,
})
export class QuickloanAppilcationStatusReportComponent implements OnInit {
  showSpinner: boolean = false;
  DateFrom: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  DateTo: any = new Date();
  DataSource: any;
  currentUser: any;
  BranchesList: any = [];
  SalesExecutiveData: any = [];
  SelectedBranchExec: any = 0;
  SelectBranch: any = " ";
  SalesExecutive: any = 0;
  SalesEx: any = 0;
  JsonData: any;
  selectedId: any;
  SelectStatus: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("detailSort") detailSort!: MatSort;

  displayedColumns: string[] = [
    "Id",
    "Application_No",
    "CustomerName",
    "Customer_PhoneNo",
    "LoanAcNo",
    "Process_Name",
    "empName",
    "BranchName",
    "ProductName",
    "ApplicationCreatedOn",
    "SourceType",
    "SourceName",
    "SalesExecutive",
    "RequiredAmount",
    "Sanction_Or_ApprovedAmount",
    "Current_Status",
    "Assigned_On",
    "CurrentProcess_TAT",
    "TAT_Hr",
    "Current_Remark",
  ];
  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private snackBar: MatSnackBar,
    private _QuickLoanService: QuickLoanService,
    private lmsService: LmsService,
    public commonFn: CommonFunctions,
    private _EncrDecrService: EncrDecrService,
    private router: Router,
  ) {}

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Application Current Status");

    this.getBranchesList();
    this.GetSalesExecutive();
  }

  searchQuickloanApplicationStatusReport() {
    this.showSpinner = true;
    this._QuickLoanService
      .QuickLoan_ApplicationStatus_Report({
        fromDate: this.DateFrom,
        toDate: this.DateTo,
        BranchId: Number(this.SelectBranch) || 0,
        LoginUserId: this.currentUser.userId,
        SalesExecutiveId: this.SalesEx,
      })
      .subscribe((response: any) => {
        console.log("Api call data", response);
        if (response.length > 0) {
          this.DataSource = new MatTableDataSource(
            JSON.parse(JSON.stringify(response)),
          );
          this.DataSource.paginator = this.paginator;
          this.DataSource.sort = this.detailSort;
          this.JsonData = response;
          this.showSpinner = false;
          console.log("Data", response);
        } else {
          this.showSpinner = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataSource = null;
        }
      });
  }
  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }
  GetSalesExecutive() {
    if (this.SelectBranch == 0) {
      this.SelectedBranchExec = " ";
    } else {
      this.SelectedBranchExec = this.SelectBranch;
    }
    {
      this.lmsService
        .Get_Collection_Ex_By_UserId({
          LoginUserId: this.currentUser.userId,
          BranchId: this.SelectedBranchExec,
        })
        .subscribe((res) => {
          this.SalesExecutiveData = JSON.parse(JSON.stringify(res));
        });
    }
  }

  applyFilter(filterValue: string) {
    this.DataSource.filter = filterValue.trim().toLowerCase();
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "application_status_report",
    ) as HTMLTableElement;
    const worksheetName = "APPLICATION STATUS REPORT";
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = worksheetName + ".xls";
    downloadLink.click();
  }

  public highlightRow(row) {
    this.selectedId = row.Loan_Id;
  }
  goToDetail(row) {
    console.log("row", row);
    let Processid = this._EncrDecrService.encrypt(
      encodeURIComponent(row.Processid),
    );
    let ProductId = this._EncrDecrService.encrypt(
      encodeURIComponent(row.productId),
    );
    let Loan_Id = this._EncrDecrService.encrypt(
      encodeURIComponent(row.Loan_Id),
    );
    var Status = "C";
    var RevertedProcessId = this._EncrDecrService.encrypt(
      encodeURIComponent(0),
    );
    var RevertedProcessName = this._EncrDecrService.encrypt(
      encodeURIComponent(""),
    );
    var RevertedEmployeeName = this._EncrDecrService.encrypt(
      encodeURIComponent(""),
    );
    var IsEdit = this._EncrDecrService.encrypt(encodeURIComponent(0));
    var RevertedCount = this._EncrDecrService.encrypt(encodeURIComponent(""));

    this.router.navigate([
      `quickloan-dashboard/quick-loan-view/details/${Processid}/${ProductId}/${Loan_Id}/${Status}/${RevertedProcessId}/${RevertedProcessName}/${RevertedEmployeeName}/${IsEdit}/${RevertedCount}`,
    ]);
  }
}
